var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"administrative-page-welcome"},[_c('app-title',{attrs:{"text":"Bienvenido al módulo administrativo de Bitacorapp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }